<div class="custom-dialog">
    <div class="header">
        <span>{{showForgotPassword ? 'Forgot Password?' : 'Login'}}</span>
        <span class="close" (click)="onClose()">x</span>
    </div>
    <div *ngIf="errorMessage" class="errorMessage">{{errorMessage}}</div>
    <mat-form-field [class.error]="showError && (!loginRequest.userName || !hasValidEmailAddress)">
        <mat-label>{{!hasValidEmailAddress && loginRequest.userName && showError ? 'Invalid Email Address' : 'Email Address'}}</mat-label>
        <input matInput type="text" [(ngModel)]="loginRequest.userName" autocomplete="off">    
    </mat-form-field>
    <mat-form-field *ngIf="!showForgotPassword" [class.error]="showError && !loginRequest.password">
        <mat-label>Password</mat-label>
        <input matInput type="text" [(ngModel)]="loginRequest.password" type="password" autocomplete="off" (keyup.enter)="onLogin()" >    
    </mat-form-field>

    <div *ngIf="!showForgotPassword" class="remember-me">
        <app-checkbox text="Remember Me" [(ngModel)]="loginRequest.rememberMe"></app-checkbox>
        <span class="reset-password" (click)="onResetPasswordClick()">Reset Password?</span>
    </div>
    <div *ngIf="showForgotPassword">
        Once you click this, please check your email for your temporary password. Login with the temporary password and be sure to change your password with the functionality provided.
    </div>

    <div class="footer">  
        <app-button *ngIf="!emailSent" (onClick)="onLogin()" label="{{showForgotPassword ? 'Send Temporary Password' : 'Login'}}" class="login-btn" className="primary-alt" [showSpinner]="showSpinner"></app-button>
        <span *ngIf="emailSent">Email Sent</span>
        <app-button *ngIf="!emailSent" (onClick)="onRegister()" label="Register" class="register-btn" className="secondary-alt"></app-button>
    </div>
    </div>